import { Navigate } from 'react-router-dom';
import { useOrganisation } from '../contexts/OrganisationContext';

// Testklient is meant for the regular tester role only. Mirrors the same
// role checks Header.jsx already uses to hide the "Testklient" nav link for
// admin/reviewer/e2e-tester/e2e-reviewer — this route guard makes that the
// same thing be true for direct URL navigation, not just the nav link.
const ProtectedTesterRoute = ({ children }) => {
    const { activeRoleId } = useOrganisation();
    const role = activeRoleId?.toLowerCase() || '';

    const isAdmin = activeRoleId === 'inera-administrator';
    const isReviewer = activeRoleId === 'inera-reviewer';
    const isE2EUser = role.endsWith('-e2e-tester');
    const isE2EReviewer = role.endsWith('-e2e-reviewer');

    // Deny by default: no role selected yet is *not* the same as being a tester.
    if (!activeRoleId || isAdmin || isReviewer || isE2EUser || isE2EReviewer) {
        return <Navigate to="/start" replace />;
    }

    return children;
};

export default ProtectedTesterRoute;
